import { ActionsObservable, ofType } from 'redux-observable';
import { CallHistoryMethodAction, push, replace } from 'connected-react-router';
import {
  CreatePageSuccessAction,
  PageActionType,
  UpdatePageSuccessAction,
} from '../../actions';
import { filter, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

type RedirectAction = UpdatePageSuccessAction | CreatePageSuccessAction;

export const redirectEpic = (
  action$: ActionsObservable<RedirectAction>,
): Observable<CallHistoryMethodAction> =>
  action$.pipe(
    ofType<RedirectAction>(
      PageActionType.UpdatePageSuccess,
      PageActionType.CreatePageSuccess,
    ),
    filter(v => !!v.redirect),
    switchMap(async (action: RedirectAction) => {
      // We're filtering incoming actions so we know redirect will not be falsy.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const { to, type } = action.redirect!;
      if (type === 'replace') {
        return replace(to);
      } else {
        return push(to);
      }
    }),
  );
